module.exports = __webpack_public_path__ + "static/media/HOW TO MANAGE REMINDER SETTINGS IN EZYMIGRATE SYSTEM.f6a5c87c.png";